import * as React from "react";

import "./branch-switcher-modal.scss";

import {cs}                       from "@Common/react/chain-services";
import {consumeContext}           from "@Common/react/context";
import {Load}                     from "@Common/react/load";
import {UseState}                 from "@Common/react/use-state";
import {ModalService3}            from "@Common/ui-components/modal-service-3/modal-service-3";
import {SearchableSelect}         from "@Common/ui-components/searchable-select/searchable-select";
import {sortMulti}                from "@Common/utils/collections";
import {chain}                    from "@Common/utils/fs";
import {equalDeep, isEmpty, omit} from "@Common/utils/objects";

import {ModalLayout} from "../modal-layout/modal-layout";

export const BranchSwitcherModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Branch Switcher Modal",
        width: 552,
        next: ({params: onSelect, close}) => next({
            onSelect: typeof onSelect === "function" ? onSelect : null,
            close,
        }),
        rootNext,
    })],

    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("userCreatedCatSubStyle"),
    consumeContext("session"),
    consumeContext("userLevels"),
    consumeContext("company"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],

    ["emulating", (_, next) => UseState({next})],
    ["state", ({session}, next) => UseState({
        defaultValue: {},
        next,
    })],
    ["branchList", ({apis}, next) => Load({
        fetch: () => apis.next.getBranchList(),
        next,
    })],
    ({modal, state, emulating, session, isInternalUser, branchList, catSubStyle, userCreatedCatSubStyle}) => ModalLayout({
        title: "Change Office",
        content: (
            <div className="branch-switcher-modal-j2s">
                <div className="form">
                    <div className="form-group">
                        <div className="control-label">
                            Current Office
                        </div>
                        <div className="control-value" xd-qa-type="label" xd-qa-name="Current Office">
                            {session.data?.branch?.branchLinkId ? (
                                session.data.branchName + ` (${session.data.branch.branchLinkId})`
                            ) : (
                                session.data.branchName
                            )}
                        </div>
                        {isInternalUser && <div className="control-internal" xd-qa-type="label" xd-qa-name="Current Office Internal ID">
                            {`Internal ID: ${session.data?.branch?.idBranch}`}
                        </div>}
                    </div>
                    <div className="form-group">
                        <div className="control-label">
                            Switch to New Office
                        </div>

                        {!branchList ? (
                            <div className="control-value" xd-qa-type="label" xd-qa-name="Loading">
                                Loading...
                            </div>
                        ) : branchList?.filter((branch) => session.value.branchId !== branch.idBranch).length === 0 ? (
                            <div className="control-value" xd-qa-type="label" xd-qa-name="No Offices">
                                No other offices available. Please log in again to switch to a different office.
                            </div>
                        ) : (
                            SearchableSelect({
                            ...isInternalUser && {
                                getSublabel: (branch) => branch.idBranch && (`Internal ID: ${branch.idBranch}`),
                            },
                            list: chain(
                                branchList?.filter((branch) => session.value.branchId !== branch.idBranch) ?? [],
                                (_) => sortMulti(_, [
                                    (branch) => branch["branchName"]?.toLowerCase(),
                                ]),
                            ),
                            loading: !branchList,
                            placeholder: "Please Select an office",
                            getLabel: (branch) => branch.branchLinkId ? (
                                branch.branchName + ` (${branch.branchLinkId})`
                            ) : (
                                branch.branchName
                            ),
                            onSelect: async (branch) => {
                                state.onChange(!branch ? {
                                } : {
                                    branchId: branch.idBranch,
                                });
                            },
                            isSelected: (branch) => state.value.branchId === branch.idBranch,

                            searchLabel: "Search a Branch",
                            xdQaName: "Office",

                        }))}
                    </div>
                </div>
            </div>
        ),
        buttons: [
            (() => {

                const newEmulation = {
                    ...state.value,
                };

                return {
                    label: emulating.value ? (
                        "Changing..."
                    ) : (
                        "Confirm Selection"
                    ),
                    primary: true,
                    disabled: (
                        isEmpty(newEmulation) ||
                        emulating.value
                    ),
                    onClick: async () => {

                        const appliedEmu = await (async () => {
                            if (equalDeep(newEmulation, session.value)) {
                                return newEmulation;
                            } else {
                                emulating.onChange(newEmulation);
                                try {
                                    return await session.applyEmulation(newEmulation);
                                } finally {
                                    emulating.onChange(null);
                                }
                            }
                        })();

                        modal.onSelect?.(appliedEmu);
                        await Promise.all([
                            catSubStyle?.reload(),
                            userCreatedCatSubStyle?.reload()
                        ]);
                        modal.close();
                    },
                };
            })(),
        ],
    }),
);
